export default `# Transcript

The transcript panel shows the complete conversation history for your session. Use it to review what's been discussed, search for specific topics, and manage session input.

---

## Viewing the Transcript

Each entry shows:
- **Speaker** — Colour-coded avatar or facilitator badge
- **Timestamp** — When the message was sent
- **Message text** — Full content with preserved formatting

Messages are colour-coded by speaker type:
- **Facilitator** — Your messages
- **Virtual Avatar** — AI avatar contributions
- **Whiteboard** — System-generated content

---

## Search & Filter

- **Search box** — Find messages by text content or speaker name
- **Filter by Speaker** — Show only Facilitator, Avatars, or Whiteboard entries
- **Auto-scroll toggle** — When enabled, the transcript automatically scrolls to the latest message

---

## Sending Messages

The input bar at the bottom provides several ways to interact:

- **Type a message** and press Enter or click Send
- **Ask All** — Request a contribution from every avatar
- **Ask Selected** — Choose specific avatars to respond
- **Microphone button** — Use speech-to-text for hands-free input. A red banner appears while recording, showing your words as they're recognised. Click **Stop** to end recording.
- **Response Mode** — Change the avatar response style from the dropdown

---

## Import & Export

- **Export** — Download the full transcript as CSV or JSON for external analysis or record-keeping
- **Import** — Load a previously recorded session or external transcript

---

## Tips

- **Use filters during review** — Filter to just avatar responses to quickly scan the ideas generated
- **Export before closing** — Always export important sessions for your records
- **Speech-to-text works well for facilitation** — Keep your hands free while managing the session`;
